import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
import { ChevronDownIcon } from "../../../common/Icons/Icons";

const BasicAccordion = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Accordion
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              'import React from "react";\n' +
              'import { Typography } from "@mui/material";\n' +
              'import Accordion from "@mui/material/Accordion";\n' +
              'import AccordionSummary from "@mui/material/AccordionSummary";\n' +
              'import AccordionDetails from "@mui/material/AccordionDetails";\n' +
              'import { ChevronDownIcon } from "../../../common/Icons/Icons";\n' +
              "\n" +
              "const Index = () => {\n" +
              "  return (\n" +
              "<Accordion>\n" +
              "                <AccordionSummary\n" +
              "                  expandIcon={\n" +
              '                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />\n' +
              "                  }\n" +
              "                >\n" +
              "                  <Typography\n" +
              '                    variant={"button"}\n' +
              '                    color={"text.secondary"}\n' +
              '                    sx={{ textTransform: "normal" }}\n' +
              "                  >\n" +
              "                    Accordion 1\n" +
              "                  </Typography>\n" +
              "                </AccordionSummary>\n" +
              "                <AccordionDetails>\n" +
              "                  <Typography>\n" +
              "                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n" +
              "                    Suspendisse malesuada lacus ex, sit amet blandit leo\n" +
              "                    lobortis eget.\n" +
              "                  </Typography>\n" +
              "                </AccordionDetails>\n" +
              "              </Accordion>\n" +
              "              <Accordion>\n" +
              "                <AccordionSummary\n" +
              "                  expandIcon={\n" +
              '                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />\n' +
              "                  }\n" +
              "                >\n" +
              "                  <Typography\n" +
              '                    variant={"button"}\n' +
              '                    color={"text.secondary"}\n' +
              '                    sx={{ textTransform: "normal" }}\n' +
              "                  >\n" +
              "                    Accordion 2\n" +
              "                  </Typography>\n" +
              "                </AccordionSummary>\n" +
              "                <AccordionDetails>\n" +
              "                  <Typography>\n" +
              "                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n" +
              "                    Suspendisse malesuada lacus ex, sit amet blandit leo\n" +
              "                    lobortis eget.\n" +
              "                  </Typography>\n" +
              "                </AccordionDetails>\n" +
              "              </Accordion>\n" +
              "              <Accordion>\n" +
              "                <AccordionSummary\n" +
              "                  expandIcon={\n" +
              '                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />\n' +
              "                  }\n" +
              "                >\n" +
              "                  <Typography\n" +
              '                    variant={"button"}\n' +
              '                    color={"text.secondary"}\n' +
              '                    sx={{ textTransform: "normal" }}\n' +
              "                  >\n" +
              "                    Accordion 3\n" +
              "                  </Typography>\n" +
              "                </AccordionSummary>\n" +
              "                <AccordionDetails>\n" +
              "                  <Typography>\n" +
              "                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n" +
              "                    Suspendisse malesuada lacus ex, sit amet blandit leo\n" +
              "                    lobortis eget.\n" +
              "                  </Typography>\n" +
              "                </AccordionDetails>\n" +
              "              </Accordion>" +
              "  );\n" +
              "};\n"
            }
          >
            <div>
              <Accordion>
                <AccordionSummary
                  expandIcon={
                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                  }
                >
                  <Typography
                    variant={"button"}
                    color={"text.secondary"}
                    sx={{ textTransform: "normal" }}
                  >
                    Accordion 1
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse malesuada lacus ex, sit amet blandit leo
                    lobortis eget.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={
                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                  }
                >
                  <Typography
                    variant={"button"}
                    color={"text.secondary"}
                    sx={{ textTransform: "normal" }}
                  >
                    Accordion 2
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse malesuada lacus ex, sit amet blandit leo
                    lobortis eget.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={
                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                  }
                >
                  <Typography
                    variant={"button"}
                    color={"text.secondary"}
                    sx={{ textTransform: "normal" }}
                  >
                    Accordion 3
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse malesuada lacus ex, sit amet blandit leo
                    lobortis eget.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicAccordion;
